const ModalOrderSpecificsContainer = {
    "OrderContainerCountTypePk": "",
    "OrderContainerCountTypeOrderFK": "",
    "OrderContainerCount": "",
    "OrderContainerType": { Code: "", Description: "" }
}


export default ModalOrderSpecificsContainer